import { z } from 'zod';
import { API } from '..';
export const versionPlatformSchema = z.enum(['carrier_app', 'customer_app']);

export const versionCheckAPISchema = z.object({
  /** the target platform */
  platform: versionPlatformSchema,
  /** current platform version such as `1.0.2` */
  version: z.string().min(1),
});
export type VersionCheckAPIData = {
  /** the status of the current version of the platform:
   *
   * - `force_update` = means the user must update to the latest version.
   * - `stable` = means there is no update required.
   * - `warning` = means the user should update the platform version but it's NOT mandatory.
   */
  status: 'force_update' | 'stable' | 'warning';
  /** the latest version of the platform */
  version: string;
  /** the current backend environment (staging, production, etc.) */
  env: string;
};

export type VersionCheckAPI = API<z.infer<typeof versionCheckAPISchema>, VersionCheckAPIData>;
